import { FilterSetType } from '@/types/userConfigs';

export const isFilterSetType = (configType: string): configType is FilterSetType =>
  (Object.values(FilterSetType) as string[]).includes(configType);
